import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";

const CreateMerchantComponent = loadable(
  () => import("../../components/Merchant/CreateMerchant")
);
const CreateMerchant = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["merchants"],
    navigateURL: "/merchant",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.MERCHANT}`;
    console.log(values)
    let formData = {
      ...values,
      "service_type": values?.service_type ? values?.service_type?.map((item: any, index: number) => (item?.value)) : [],
      "product_type": values?.product_type ? values?.product_type?.map((item: any, index: number) => (item?.value)) : [],
      "service_city": values?.service_city ? values?.service_city?.map((item: any, index: number) => (item?.value)) : [],
      "service_branch": values?.service_branch ? values?.service_branch?.map((item: any, index: number) => (item?.value)) : [],
      "mobile_number": `+977${values?.mobile_number}`,
      "secondary_contact": values?.secondary_contact ? `+977${values?.secondary_contact}` : `+977${values?.mobile_number}`
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Merchant</span>
      </div>
      <CreateMerchantComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateMerchant;
